import { Component, Input } from '@angular/core';
import { IrisButtonContainerMobileLayouts } from '@sondermind/iris/button';
import { IrisButtonTypeAttributeOptions } from '@sondermind/iris/shared';

@Component({
  selector: 'page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})

export class PageNotFoundComponent {
  @Input() therapyMatchFlowUrl: string = '';
  IrisButtonContainerMobileLayouts = IrisButtonContainerMobileLayouts;
  IrisButtonTypeAttributeOptions = IrisButtonTypeAttributeOptions;
}
